export const onDocumentLoadSuccess = (loadedPages, setNumPages) => {
  setNumPages(loadedPages);
  console.log(`PDF loaded successfully: ${loadedPages} pages`);
};

export const onDocumentLoadError = (error, setStatusCode) => {
  console.log("Error loading PDF:", error);
  setStatusCode(HTTP_STATUS_CODE.INTERNAL_SERVER_ERROR);
};

export const CONTENT_TYPE = {
  PDF: "application/pdf",
  IMAGE_JPEG: "image/jpeg",
  IMAGE_PNG: "image/png"
};

export const CUSTOM_STATUS_CODE = {
  LOADING: 0
};

export const HTTP_STATUS_CODE = {
  OK: 200,
  FORBIDDEN: 403,
  INTERNAL_SERVER_ERROR: 500
};

/** Standard Status Codes
 * 200 = OK
 * 400 = Bad Request
 * 401 = Unauthorized
 * 403 = Forbidden
 * 404 = Not Found
 * 500 = Internal Server Error
 */

export const statusCodeMap = {
  0: "Loading...",
  400: "The request is malformed, invalid, or cannot be understood by the server.",
  401: "User is not authenticated or token has expired.",
  403: "User is forbidden to access the resource.",
  404: "Resource not found.",
  500: "Internal server error."
};

export const clientErrorStatusCodes = Object.keys(statusCodeMap).map(Number);
export const DEFAULT_PATH = "/ext/publication";
export const JAPI_BASE_PATH = "/research/japi";
export const LOCALHOST_JAPI_URL = `http://localhost:9090${JAPI_BASE_PATH}`;

export const getBaseJapiUrl = () => {
  if (window.location.hostname.includes("localhost")) return LOCALHOST_JAPI_URL;
  return `${window.location.origin}${JAPI_BASE_PATH}`;
};
